import { OvelayContainer } from "./style";

export default function Mascara(props) {
  return (<OvelayContainer {...props} />)
}
